"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var BaseComponent_1 = require("./base/BaseComponent");
var ko = require("knockout");
var MobileVideoPlayerComponent = (function (_super) {
    __extends(MobileVideoPlayerComponent, _super);
    function MobileVideoPlayerComponent(params, element, templateNodes) {
        var _this = this;
        _super.call(this, params, element, templateNodes);
        this.url = ko.observable("");
        this.width = 300;
        this.height = 200;
        this.providers = [
            {
                test_regex: /^.+(?:(?:vk\.ru)|(?:vk\.com)|(?:vkvideo\.ru))\/(?:.+)?((vkvideo)|(video))[^_&]+/,
                url_regex: /(?:https?:\/\/)?(?:www\.)?(?:(?:vk\.ru)|(?:vk\.com)|(?:vkvideo\.ru))(?:.+)?(?:video)([0-9a-zA-Z_\-]+)_([0-9a-zA-Z_\-]+)%?(?:.*)/g,
                url_text: "//vk.ru/video_ext.php?oid=$1&id=$2",
                html: '<iframe width="100%" height="{height}" src="{url}" frameborder="0" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true" allowtransparency="true"></iframe>',
                provider: "vk"
            },
            {
                test_regex: /^.+(?:(?:vk\.ru)|(?:vk\.com)|(?:vkvideo\.ru))\/(?:.*clip)(.+)/,
                url_regex: /(?:https?:\/\/)?(?:www\.)?(?:(?:vk\.ru)|(?:vk\.com)|(?:vkvideo\.ru))\/(?:.*clip)([0-9a-zA-Z_\-]+)_([0-9a-zA-Z]+)(?:.*)/g,
                url_text: "//vk.ru/video_ext.php?oid=$1&id=$2",
                html: '<iframe width="100%" height="646" src="{url}" frameborder="0" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true" allowtransparency="true"></iframe>',
                provider: "vk"
            },
            {
                test_regex: /^.+(yappy.media)\/video?[^_&]+/,
                url_regex: /(?:https?:\/\/)?(?:www\.)?(?:yappy\.media)\/(?:video)\/([0-9a-zA-Z_\-]+)/g,
                url_text: "//yappy.media/default/embed/$1",
                html: '<iframe width="100%" height="640" src="{url}" frameborder="0" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true" allowtransparency="true"></iframe>',
                provider: "yappy"
            },
            {
                test_regex: /^.+(rutube.ru)(?!\/yappy)(?!\/live)\/[^_&\n]+/,
                url_regex: /(?:https?:\/\/)?(?:www\.)?(?:rutube\.ru)(?:\/shorts)?(?:\/video)?(?:\/private)?\/([0-9a-zA-Z_\-]+\/\?\S*)?\s*/g,
                url_text: "//rutube.ru/play/embed/$1",
                html: '<iframe width="100%" height="{height}" src="{url}" frameborder="0" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true" allowtransparency="true"></iframe>',
                provider: "rutube"
            },
            {
                test_regex: /^.*((youtu.be)|(youtube.com))\/((v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))?\??v?=?([^#\&\?]*).*/,
                url_regex: /(?:https?:\/\/)?(?:www\.)?(?:m\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=|embed\/|shorts\/)?([0-9a-zA-Z_\-]+)(.+)?/g,
                url_text: "//www.youtube.com/embed/$1",
                html: '<iframe width="100%" height="{height}" src="{url}?wmode=opaque" frameborder="0" allowfullscreen></iframe>',
                provider: "youtube"
            },
            {
                test_regex: /^.*(?:vimeo.com)\/(?:channels(\/\w+\/)?|groups\/*\/videos\/\u200b\d+\/|video\/|)(\d+)(?:$|\/|\?)/,
                url_regex: /(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_\-]+)?/i,
                url_text: "//player.vimeo.com/video/$1",
                html: '<iframe width="100%" height="{height}" src="{url}" frameborder="0" allowfullscreen></iframe>',
                provider: "vimeo"
            }
        ];
        this.html = ko.computed(function () {
            var videoUrl = _this.url();
            if (!videoUrl)
                return "";
            var providers = _this.providers;
            var width = _this.width.toString();
            var height = _this.height.toString();
            var html = "";
            for (var i = 0; i < providers.length; i++) {
                var p = providers[i];
                if (p.test_regex.test(videoUrl)) {
                    var embedUrl = videoUrl.replace(p.url_regex, p.url_text);
                    html = p.html
                        .replace("{url}", embedUrl)
                        .replace("{width}", width)
                        .replace("{height}", height);
                    break;
                }
            }
            return html;
        });
        if (params.width)
            this.width = params.width;
        if (params.height)
            this.height = params.height;
        this.url(ko.utils.unwrapObservable(params.url));
    }
    return MobileVideoPlayerComponent;
}(BaseComponent_1.default));
ko.components.register("mobile-video-player", {});
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = MobileVideoPlayerComponent;
//# sourceMappingURL=mobileVideoPlayer.js.map